// extracted by mini-css-extract-plugin
export default {"forgot-password-input":"ForgotPassword_forgot-password-input__VJCQo"};